export const INDIAN_PHONE_ERROR_MESSAGE =
  'Please enter a valid Indian mobile number (10 digits starting with 6, 7, 8, or 9).';

const INDIAN_PHONE_REGEX = /^[6-9]\d{9}$/;

export const sanitizeIndianPhoneInput = (input: string): string => {
  if (!input) return '';

  let digits = input.replace(/\D/g, '');

  // Allow users to paste values like +91 98765 43210
  if (digits.length > 10 && digits.startsWith('91')) {
    digits = digits.slice(2);
  }

  digits = digits.slice(0, 10);

  if (digits.length > 0 && !/^[6-9]/.test(digits)) {
    return '';
  }

  return digits;
};

export const isValidIndianPhoneNumber = (input: string): boolean => {
  const phone = sanitizeIndianPhoneInput(input);
  return INDIAN_PHONE_REGEX.test(phone);
};

export const formatIndianPhoneForDisplay = (input: string): string => {
  const digits = sanitizeIndianPhoneInput(input);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)} ${digits.slice(5, 10)}`;
};
